export default function castToBoolean(
  value: string | boolean | number
): boolean {
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }
  return Boolean(value);
}
